import React from "react";
import { connect, useDispatch } from "react-redux";

import { setActiveTab, initPagination, showModal, clearSelectedOpportunity } from "actions";
import OpportunitiesFilterForm from "./OpportunitiesFilterForm";
import OpportunitiesTable from "./OpportunitiesTable";
import ButtonCreate from "../../components/buttons/ButtonCreate";
import { OPPORTUNITY_MODAL } from "../../components/modals";

const OpportunitiesPage = props => {
  React.useEffect(() => {
    document.title = "LifeRoc | Opportunities";
  }, []);

  return (
    <div>
      <OpportunitiesFilterForm />
      <div style={{ marginBottom: "1rem" }}>
        <ButtonCreate
          onClick={() => {
            props.clearSelectedOpportunity();
            props.showModal(OPPORTUNITY_MODAL);
          }}
          key="create"
        >
          Add Opportunity
        </ButtonCreate>
      </div>
      <OpportunitiesTable />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps, {
  setActiveTab,
  initPagination,
  clearSelectedOpportunity,
  showModal,
})(OpportunitiesPage);
